export const LEARN_EMPLOYER = [
  {
    mainHead: "Learn More for Employers",
    mainDisc: "Why Use Film Help Squad for Finding Talents?",
    mainSubDesc:
      "Are you in search of top-tier talent for your film projects? Look no further. Film Help Squad offers a dynamic and comprehensive platform designed to simplify your talent search and streamline your recruitment process.",
    subData: [
      {
        subHead: "Here's why employers like you choose Film Help Squad:",
        subHeadData: [
          {
            subHeadType: "Access to a Global Talent Pool:",
            subDesc:
              "Film Help Squad connects you with a diverse and international pool of filmmakers, actors, writers, and industry professionals. Find the perfect talent, regardless of location, to bring your creative visions to life.",
          },
          {
            subHeadType: "Specialized Expertise:",
            subDesc:
              "Our platform caters specifically to the film and entertainment industry. This means you can find talent with expertise in areas like screenwriting, cinematography, acting, and more, ensuring that your projects are in the hands of skilled professionals.",
          },
          {
            subHeadType: "Efficient Recruitment:",
            subDesc:
              "Save time and resources with our efficient recruitment tools. Easily post job listings, review applications, and communicate with potential candidates—all in one place.",
          },
        ],
      },
      {
        subHead: "Features and Benefits",
        subHeadData: [
          {
            subHeadType: "1. Job Listings:",
            li: "Post detailed job listings for various positions within the film industry.",
            li1: "Include job descriptions, requirements, and application deadlines.",
          },
          {
            subHeadType: "2. Talent Search:",
            li: "Browse a diverse database of talent profiles.",
            li1: "Filter results based on skills, location, and availability.",
          },
          {
            subHeadType: "3. Application Management:",
            li: "Easily review and manage incoming applications from talent.",
            li1: "Streamline your hiring process and make informed decisions.",
          },
          {
            subHeadType: "4. Collaboration Tools:",
            li: "Connect and collaborate with talent directly on the platform.",
            li1: "Share project details, scripts, and creative ideas securely.",
          },
          {
            subHeadType: "5. Talent Insights:",
            li: "Gain insights into talent portfolios, experience, and past projects.",
            li1: "Make data-driven decisions when hiring.",
          },
          {
            subHeadType: "6. Privacy Controls:",
            li: "Maintain control over who can view your job listings and contact you.",
            li1: "Protect your privacy while recruiting.",
          },
        ],
      },
      {
        subHead: "Tools for Employers",
        subHeadData: [
          {
            subHeadType: "1. Job Posting Wizard:",
            subDesc:
              "Our user-friendly job posting tool guides you through creating compelling job listings.",
          },
          {
            subHeadType: "2. Messaging System:",
            subDesc:
              "Communicate with potential talent within the platform, keeping all conversations organized.",
          },
          {
            subHeadType: "3. Talent Shortlisting:",
            subDesc:
              "Create shortlists of the most promising candidates for further consideration.",
          },
          {
            subHeadType: "4. Analytics Dashboard:",
            subDesc:
              "Track the performance of your job listings and the engagement of your posts.",
          },
        ],
      },
    ],
    howWorkData: [
      {
        heading: "How It Works",
        subHW: [
          {
            q: "Post a Job:",
            ans: "Start by posting a job listing that outlines your project's needs and requirements.",
          },
          {
            q: "Discover Talent:",
            ans: "Browse talent profiles or wait for applicants to express interest in your job.",
          },
          {
            q: "Review and Connect:",
            ans: "Review applications, shortlist candidates, and initiate conversations with potential talent.",
          },
          {
            q: "Collaborate and Hire:",
            ans: "Collaborate with your selected talent to bring your project to life, whether it's casting for a role or assembling a production team.",
          },
        ],
      },
    ],
    footerText:
      "Ready to find the perfect talent for your next cinematic masterpiece? Join Film Help Squad today and experience the difference in streamlined recruitment and access to top-tier talent.",
  },
];
